var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 2.46967C12.8232 2.76256 12.8232 3.23744 12.5303 3.53033L11.0606 5L12.5303 6.46967C12.8232 6.76256 12.8232 7.23744 12.5303 7.53033C12.2374 7.82322 11.7625 7.82322 11.4697 7.53033L9.82321 5.88388C9.33505 5.39573 9.33505 4.60427 9.82321 4.11612L11.4697 2.46967C11.7625 2.17678 12.2374 2.17678 12.5303 2.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0209 6.52859C13.9388 5.9311 12.7038 5.66792 11.4721 5.77234C11.0593 5.80732 10.6964 5.5011 10.6614 5.08837C10.6264 4.67564 10.9326 4.31269 11.3454 4.2777C12.8727 4.14822 14.4041 4.47456 15.746 5.21545C17.0878 5.95633 18.1799 7.07849 18.884 8.44001C19.5881 9.80153 19.8726 11.3413 19.7016 12.8645C19.5306 14.3877 18.9118 15.8261 17.9234 16.9976C16.9349 18.1691 15.6213 19.0213 14.1486 19.4462C12.6759 19.8712 11.1102 19.8499 9.64958 19.385C8.18897 18.9201 6.899 18.0326 5.94281 16.8346C4.98663 15.6366 4.40716 14.1819 4.27769 12.6546C4.2427 12.2419 4.54892 11.8789 4.96166 11.8439C5.37439 11.809 5.73734 12.1152 5.77233 12.5279C5.87674 13.7596 6.34405 14.9327 7.11517 15.8989C7.88629 16.865 8.92658 17.5807 10.1045 17.9556C11.2824 18.3305 12.545 18.3477 13.7327 18.005C14.9204 17.6623 15.9798 16.9751 16.7769 16.0303C17.574 15.0855 18.0731 13.9256 18.211 12.6972C18.3489 11.4688 18.1194 10.227 17.5516 9.12904C16.9838 8.03104 16.1031 7.12607 15.0209 6.52859Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh2);
export default __webpack_public_path__ + "static/media/refresh-2.c95e94ee.svg";
export { ForwardRef as ReactComponent };